import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { candidacyInfoQueryKey } from "@/hooks/queries/useGetCandidacyInfo";
import { CandidacyInfoResponse } from "@/types";

// Updates fields on the candidacy-info query without refetching it.
export const useSetCandidacyInfo = () => {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();
  const queryClient = useQueryClient();

  return ({
    candidacyId,
    ...updates
  }: { candidacyId: string } & Partial<Omit<CandidacyInfoResponse, "id">>) => {
    queryClient.setQueryData<CandidacyInfoResponse>(
      candidacyInfoQueryKey(currentCompanyId, currentJobId, candidacyId),
      (existing) => (existing ? { ...existing, ...updates } : existing),
    );
  };
};
